import React, { useState, useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';

function Router() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    // Listen for popstate events (back/forward navigation)
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Route matching
  if (currentPath === '/') {
    return <Home />;
  }
  
  if (currentPath === '/admin') {
    return <Admin />;
  }

  return <NotFound />;
}

export default function App() {
  return (
    <LanguageProvider>
      <Router />
      <Toaster 
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: '#1a1b25',
            color: '#fff',
            border: '1px solid #27272a',
          },
        }}
      />
    </LanguageProvider>
  );
}
